import {ReactElement} from "react";
import {ThemeProvider} from "@mui/material";
import {WebPage} from "../types";
import useResizeObserver from "use-resize-observer";
import {SiteTemplate} from "../page-components/types";

export enum SectionViewMode {
  THUMBNAIL,
  PREVIEW,
  EDITOR,
}

export function SectionView(props: {
  id?: string,
  mode: SectionViewMode,
  webPage: WebPage,
  template: SiteTemplate,
  sectionIndex: number,
  zoom?: number,
  selectedSectionIndex?: number,
  setSelectedSectionIndex?: (index: number) => void,
  selectedImage?: string,
  setSelectedImage?: (image: string) => void,
  style?: any,
}): ReactElement {
  const section = props.webPage.sections[props.sectionIndex];
  const PageSection = props.template.PageSections[section.name];
  const {ref, width = 1} = useResizeObserver<HTMLDivElement>();
  return <ThemeProvider theme={props.template.theme}>
    <div
      id={props.id}
      ref={ref}
      style={{
        display: "flex",
        flexGrow: 1,
        width: "100%",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
      }}>
      <div
        style={{
          pointerEvents: props.mode !== SectionViewMode.PREVIEW ? "none" : undefined,
          zoom: Math.min(width * (props.mode === SectionViewMode.THUMBNAIL ? 1 : props.zoom || 1) / 1200, 1),
          width: 1200,
          display: "flex",
          flexDirection: "column",
          padding: 0,
          background: "white",
          ...props.style,
        }}>
        <PageSection
          template={props.template}
          /*@ts-ignore*/
          data={section.data}/>
      </div>
      {props.mode !== SectionViewMode.PREVIEW
        ? <div
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            props.setSelectedSectionIndex?.(props.sectionIndex);
          }}
          style={{
            cursor: Boolean(props.setSelectedSectionIndex) ? "pointer" : undefined,
            position: "absolute", left: 0, top: 0, width: "100%", height: "100%"
          }}/>
        : null}
    </div>
  </ThemeProvider>;
}